import { createSelector } from 'reselect';
import { autoReplenishEmbeddedSelector } from 'selectors/testTarget/offers/autoReplenishEmbedded/autoReplenishEmbeddedSelector';

const showSelector = createSelector(autoReplenishEmbeddedSelector, autoReplenishEmbedded => !!autoReplenishEmbedded.active);

export { showSelector };
